import { Controller } from '@hotwired/stimulus'
import { Chart } from 'chart.js/auto'

export default class extends Controller {
  static targets = [
    'categoryChart',
    'trendChart'
  ]
  static values = {
    categoryChartData: String,
    trendChartData: String
  }

  connect() {
    this.categoryChartData = JSON.parse(this.categoryChartDataValue)
    this.trendChartData = JSON.parse(this.trendChartDataValue)
    this.renderCategoryChart()
    this.renderTrendChart()
  }

  renderCategoryChart() {
    new Chart(
      this.categoryChartTarget.getContext('2d'),
      {
        type: 'pie',
        data: {
          labels: this.categoryChartData.map(item => {
            const formattedAmount = new Intl.NumberFormat('pt-BR', {
              style: 'currency',
              currency: 'BRL',
            }).format(item.total)

            return `${item.category} - ${formattedAmount}`
          }),
          datasets: [
            {
              data: this.categoryChartData.map(item => item.total),
            }
          ]
        },
        options: {
          responsive: true,
          maintainAspectRatio: false,
          plugins: {
            legend: {
              display: true,
              position: 'right',
              labels: {
                usePointStyle: true,
                boxWidth: 8,
                font: {
                  size: 11,
                },
              },
            },
            tooltip: {
              callbacks: {
                label: function(context) {
                  return new Intl.NumberFormat('pt-BR', {
                    style: 'currency',
                    currency: 'BRL'
                  }).format(context.raw)
                }
              }
            }
          }
        }
      }
    )
  }

  renderTrendChart() {
    new Chart(
      this.trendChartTarget.getContext('2d'),
      {
        type: 'line',
        data: {
          labels: this.trendChartData.map(item => item.period),
          datasets: [
            {
              label: 'Despesas',
              data: this.trendChartData.map(item => item.total_spent),
              borderColor: 'rgba(255, 99, 132, 1)',
              backgroundColor: 'rgba(255, 99, 132, 0.2)',
              tension: 0.5
            },
            {
              label: 'Receitas',
              data: this.trendChartData.map(item => item.total_received),
              borderColor: 'rgba(54, 162, 235, 1)',
              backgroundColor: 'rgba(54, 162, 235, 0.2)',
              tension: 0.5
            }
          ]
        },
        options: {
          responsive: true,
          maintainAspectRatio: false,
          plugins: {
            tooltip: {
              callbacks: {
                label: function(context) {
                  return new Intl.NumberFormat('pt-BR', {
                    style: 'currency',
                    currency: 'BRL'
                  }).format(context.raw)
                }
              }
            }
          }
        }
      }
    )
  }
}
